export default "__VITE_ASSET__IFn8C6d$__"